export const tipoDimensionamento = [
  { value: '0', label: 'Compensar consumo Fora Ponta:', labelAlternativa: 'Compensar consumo Demanda Contratada:' },
  { value: '1', label: 'Compensar consumo Fora Ponta + Ponta:' },
];
